import React from "react";

// Auto-scrolling marquee gallery of looping muted clips + photos for social proof.
// items: [{ video: "/clips/x.mp4" } | { image: "url" }, label?: string]
export function MotionGallery({ items, accent = "#8b5cf6", testid = "motion-gallery" }) {
  const loop = [...items, ...items];
  return (
    <div className="marquee-mask overflow-hidden py-2" data-testid={testid}>
      <div className="marquee-track flex gap-5 w-max">
        {loop.map((it, i) => (
          <figure
            key={i}
            className="group relative shrink-0 w-[240px] md:w-[290px] aspect-[3/4] rounded-2xl overflow-hidden border border-white/10"
            style={{ boxShadow: `0 14px 44px ${accent}22` }}
            data-testid={i < items.length ? `${testid}-item-${i}` : undefined}
          >
            {it.video ? (
              <video className="h-full w-full object-cover" autoPlay muted loop playsInline preload="auto">
                <source src={it.video} type="video/mp4" />
                <source src={it.video.replace(".mp4", ".webm")} type="video/webm" />
              </video>
            ) : (
              <img src={it.image} alt={it.label || ""} className="h-full w-full object-cover" loading="lazy" />
            )}
            {it.label && (
              <figcaption className="absolute bottom-0 inset-x-0 p-4 bg-gradient-to-t from-black/80 to-transparent">
                <span className="font-mono text-[10px] tracking-[0.15em] uppercase" style={{ color: accent }}>{it.label}</span>
              </figcaption>
            )}
          </figure>
        ))}
      </div>
    </div>
  );
}
